import React from "react";
import { IMG, SITE } from "../lib/data";

export default function AboutHH() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="bg-[hsl(var(--hh-bone))] py-20 md:py-28 lg:py-32"
    >
      <div className="container-hh grid grid-cols-12 gap-x-4 gap-y-10 md:gap-10 lg:gap-16 items-center">
        <div className="col-span-12 md:col-span-7 reveal">
          <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8">
            <span className="accent-line" />
            <span className="overline text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.65rem" }}>
              Nosotros
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
            Veinticinco años{" "}
            <em style={{ fontStyle: "italic", color: "hsl(var(--hh-moss))" }}>
              construyendo
            </em>{" "}
            hogares.
          </h2>
          <p className="mt-6 md:mt-8 max-w-xl text-[hsl(0,0%,28%)] text-sm sm:text-base md:text-lg leading-relaxed">
            House &amp; Home lleva 25 años construyendo sueños y brindando seguridad a
            través de sus proyectos. Trabajamos para satisfacer a todo tipo de clientes,
            siempre apoyados por <strong className="font-medium">Constructora CVJ</strong>.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4 md:gap-10 max-w-md">
            <div>
              <div className="font-display text-3xl md:text-4xl">25+</div>
              <div className="overline mt-2 text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.58rem" }}>Años</div>
            </div>
            <div>
              <div className="font-display text-3xl md:text-4xl">20+</div>
              <div className="overline mt-2 text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.58rem" }}>Proyectos</div>
            </div>
            <div>
              <div className="font-display text-3xl md:text-4xl">100%</div>
              <div className="overline mt-2 text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.58rem" }}>Entregados</div>
            </div>
          </div>

          <div className="mt-10 flex items-center gap-3 sm:gap-4">
            <span className="overline text-[hsl(0,0%,40%)]" style={{ fontSize: "0.58rem" }}>
              Impulsados por
            </span>
            <img
              src={IMG.logoCVJ}
              alt="Constructora CVJ"
              className="h-7 md:h-8 w-auto"
              style={{ filter: "invert(1) brightness(0)" }}
            />
          </div>
        </div>

        <div className="col-span-12 md:col-span-5 reveal">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={IMG.heroBg}
              alt="Proyecto residencial House & Home"
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
